import { render, staticRenderFns } from "./MyNotifications.vue?vue&type=template&id=31af9524"
import script from "./MyNotifications.vue?vue&type=script&lang=js"
export * from "./MyNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31af9524')) {
      api.createRecord('31af9524', component.options)
    } else {
      api.reload('31af9524', component.options)
    }
    module.hot.accept("./MyNotifications.vue?vue&type=template&id=31af9524", function () {
      api.rerender('31af9524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/notification/MyNotifications.vue"
export default component.exports